module.exports = __webpack_public_path__ + "img/news.bdc42689.svg";